module.exports = __webpack_public_path__ + "static/media/icn_mercantil_blanco.21975072.png";